/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-02 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DisplayText, TextStyle, Button } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import welcome from 'src/assets/images/dashboard/welcome.png';
import { routes } from 'src/routes';
import history from 'src/routes/history';

type Props = {
  name: string
};

type ComposedProps = Props & WithI18nProps;
class welcomeOldLowPlus extends Component<ComposedProps> {
  render() {
    const { name, i18n } = this.props;

    return (
      <div className="BC-Welcome__Dashboard">
        <div className="Container--flexHorizontal" style={{ justifyContent: 'space-between', flexWrap: 'wrap' }}>
          <div className="Container--flexVertical">
            <DisplayText size="large">
              {i18n.translate('AdminHTML.Dashboard.Common.happyHolidayName', { nt_name: name })}
            </DisplayText>
            <DisplayText size="small">
              <TextStyle variation="subdued">
                {i18n.translate('AdminHTML.Dashboard.WelcomeOldLowPlus.textStyle_Content', {
                  t: (
                    <TextStyle variation="strong">
                      {i18n.translate('AdminHTML.Dashboard.WelcomeOldLowPlus.textStyle_Content_t')}
                    </TextStyle>
                  )
                })}
              </TextStyle>
            </DisplayText>
            <Button
              primary
              onClick={() => {
                history.push(
                  `${routes.subscription.discount()}?utm_source=BoostPFS&utm_medium=welcome%20box&utm_campaign=Upsell%20Plus%20Plan%20BFCM%202020&utm_content=plan1to5`
                );
              }}>
              {i18n.translate('AdminHTML.Dashboard.WelcomeOldLowPlus.buttonChildren')}
            </Button>
          </div>
          <img src={welcome} alt={i18n.translate('AdminHTML.Dashboard.Common.welcome')} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const externalInfo = _.get(state.oauth.tenantApp, 'externalInfo', {});
  return {
    name: _.get(externalInfo, 'name', '')
  };
};

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(welcomeOldLowPlus));
